import { format, parseISO, intlFormat } from 'date-fns';
export default {
    methods: {
        formatDate(date, dateFormat = 'dd/MM/yyyy') {
            return format(
                typeof date !== 'string' ? date : parseISO(date),
                dateFormat
            );
        },
        isContractAgent(job) {
            return job?.applicationType?.code?.toLowerCase() === 'ca';
        },
        isTemporaryAgent(job) {
            return job?.applicationType?.code?.toLowerCase() === 'ta';
        },
        formatDateLocale(date){
            let locale = window._HR.selectedLanguage === 'EN' ? 'EN-gb' : 'Fr-fr'
            let isoDate = parseISO(date)
            return intlFormat(
                isoDate,
                {
                    year:'numeric',
                    month: 'long',
                    day: 'numeric'
                }, {
                    locale: locale
                }
            );
        }
    },
};
